import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import { productPreviews } from "./productPreviews";

export default function HomePreviewCarousel({ paused = false }) {
  const [index, setIndex] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [hidden, setHidden] = useState(document.hidden);
  const rotating = playing && !hidden && !paused;

  useEffect(() => {
    const visibility = () => setHidden(document.hidden);
    document.addEventListener("visibilitychange", visibility);
    return () => {
      document.removeEventListener("visibilitychange", visibility);
    };
  }, []);
  useEffect(() => {
    if (!rotating) return;
    const timer = setInterval(() => setIndex(value => (value + 1) % productPreviews.length), 6000);
    return () => clearInterval(timer);
  }, [rotating]);

  function select(value) { setIndex(value); setPlaying(false); }
  return <div className="home-preview-slot"><figure className="home-preview" role="region" aria-roledescription="carousel" aria-label="SignalTuner product previews"
    onFocusCapture={event => {
      if (!event.target.closest(".home-preview-play")) setPlaying(false);
    }}>
    <div className="home-preview-stage" aria-live={rotating ? "off" : "polite"} aria-atomic="true">
      {productPreviews.map((preview, position) => <div key={preview.file} className="home-preview-slide" hidden={position !== index}
        role="group" aria-roledescription="slide" aria-label={`${position + 1} of ${productPreviews.length}: ${preview.title}`}>
        <img className="home-preview-image" src={`${process.env.PUBLIC_URL}/${preview.file}`} alt={preview.alt} loading={position === 0 ? "eager" : "lazy"} />
      </div>)}
    </div>
    <div className="home-preview-controls">
      <div className="home-preview-selectors" role="group" aria-label="Choose a preview">{productPreviews.map((preview, position) =>
        <button key={preview.file} type="button" aria-label={`Show ${preview.title.toLowerCase()}`} aria-pressed={position === index} onClick={() => select(position)}><span /></button>
      )}</div>
      <button type="button" className="home-preview-play" aria-label={playing ? "Pause slideshow" : "Play slideshow"} onClick={() => setPlaying(value => !value)}><FontAwesomeIcon icon={playing ? faPause : faPlay} aria-hidden="true" /></button>
    </div>
  </figure></div>;
}
